import type { RoutineApprovalCardProps } from '@heidi/agents';
import { CreateWorkflowApprovalCard } from './CreateWorkflowApprovalCard';

export { CreateWorkflowApprovalCard };

type WorkflowAliasApprovalProps = Pick<
  RoutineApprovalCardProps,
  'approval' | 'onResolve'
>;

export function ScheduleWorkflowApprovalCard(
  props: WorkflowAliasApprovalProps
): JSX.Element {
  return <CreateWorkflowApprovalCard {...props} />;
}

export function EventTriggersApprovalCard(
  props: WorkflowAliasApprovalProps
): JSX.Element {
  return <CreateWorkflowApprovalCard {...props} />;
}
